export default [
  {
    path: '/bons-remboursement',
    name: 'bon-a-rembourser-list',
    props: true,
    component: () => import('@/views/ToBeReimbursedVouchers/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Liste des bons de remboursement',
      pageDesc: 'Consultez, filtrez et gérez les bons de remboursement logistiques. Accédez aux détails, créez ou modifiez des bons à rembourser pour une gestion efficace des flux financiers.',
      accessibility: {
        ariaLabel: 'Liste des bons de remboursement logistiques',
        breadcrumbLabel: 'Fil d’Ariane des bons de remboursement',
      },
      breadcrumb: [
        {
          text: 'Bons de remboursement',
          to: { name: 'bon-a-rembourser-list' },
          ariaLabel: 'Accueil des bons de remboursement',
        },
        {
          text: 'Liste des bons de remboursement',
          active: true,
          ariaLabel: 'Liste des bons de remboursement',
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'supplier', 'sales'],
    },
  },
  {
    path: '/bons-remboursement/create',
    name: 'bons-remboursement-add',
    props: true,
    component: () => import('@/views/ToBeReimbursedVouchers/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Créer un bon de remboursement',
      pageDesc: 'Créez un nouveau bon de remboursement en sélectionnant le fournisseur et les colis concernés. Suivez les instructions pour garantir la conformité des données.',
      accessibility: {
        ariaLabel: 'Création d’un bon de remboursement logistique',
        breadcrumbLabel: 'Fil d’Ariane création bon de remboursement',
      },
      breadcrumb: [
        {
          text: 'Bons de remboursement',
          to: { name: 'bon-a-rembourser-list' },
          ariaLabel: 'Accueil des bons de remboursement',
        },
        {
          text: 'Créer un bon de remboursement',
          active: true,
          ariaLabel: 'Créer un bon de remboursement',
        },
      ],
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/bons-a-rembourser/change-status',
    name: 'bons-a-rembourser-change-status',
    props: true,
    component: () => import('@/views/ToBeReimbursedVouchers/ChangeStatus.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Changer le statut des colis à rembourser',
      pageDesc: 'Modifiez le statut des colis à rembourser pour assurer un suivi précis des remboursements logistiques.',
      accessibility: {
        ariaLabel: 'Changement de statut des colis à rembourser',
        breadcrumbLabel: 'Fil d’Ariane changement statut bon de remboursement',
      },
      breadcrumb: [
        {
          text: 'Bons de remboursement',
          to: { name: 'bon-a-rembourser-list' },
          ariaLabel: 'Accueil des bons de remboursement',
        },
        {
          text: 'Changer le statut',
          active: true,
          ariaLabel: 'Changer le statut des colis à rembourser',
        },
      ],
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/bons-a-rembourser/show/:id',
    name: 'bon-a-rembourser-show',
    props: true,
    component: () => import('@/views/ToBeReimbursedVouchers/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détails du bon de remboursement',
      pageDesc: 'Consultez les informations détaillées du bon de remboursement, y compris les colis, montants et statuts associés.',
      accessibility: {
        ariaLabel: 'Détails du bon de remboursement logistique',
        breadcrumbLabel: 'Fil d’Ariane détails bon de remboursement',
      },
      breadcrumb: [
        {
          text: 'Bons de remboursement',
          to: { name: 'bon-a-rembourser-list' },
          ariaLabel: 'Accueil des bons de remboursement',
        },
        {
          text: 'Détails du bon de remboursement',
          active: true,
          ariaLabel: 'Détails du bon de remboursement',
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'supplier', 'sales'],
    },
  },
]
